export default __webpack_public_path__ + "static/grid-cloud2-7255baf382056ebc5d345286b690a294.mp4";